import { useEffect } from 'react';
import { Toast } from '@heroui/react';
import { AppRouter } from '@/containers/AppRouter';
import { useThemeStore } from '@/store/themeSlice';

export default function App() {
  const theme = useThemeStore((s) => s.theme);

  useEffect(() => {
    const root = document.documentElement;
    root.setAttribute('data-theme', theme);
    root.classList.toggle('dark', theme === 'dark');
    root.classList.toggle('light', theme === 'light');
  }, [theme]);

  return (
    <>
      <AppRouter />
      {/* рендерит глобальную очередь императивного toast() */}
      <Toast.Provider />
    </>
  );
}
